import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { VariousCrownIcon, VariousShieldIcon } from '../../ui/Icons';

type TopProIconProps = {
  width?: number;
  height?: number;
  active?: boolean;
};

export const TopProIcon = ({
  width = 24,
  height = 25,
  active = false,
}: TopProIconProps) => (
  <VariousShieldIcon
    width={width}
    height={height}
    backgroundColor={active ? BrandColor.Purple : BrandColor.Transparent}
    borderColor={active ? BrandColor.Purple : BrandColor.Silver}
  >
    <VariousCrownIcon color={active ? BrandColor.YellowHighlight : BrandColor.Silver} />
  </VariousShieldIcon>
);
